'use client';

import { useCurrency } from '@/lib/currency/CurrencyContext';
import { formatPrice } from '@/lib/currency/formatPrice';

/**
 * Tiny presentation component for "format this ILS amount in the user's
 * currently selected currency." Use anywhere a raw price needs to render —
 * server components included (they receive this as a client island).
 *
 * For the rich price treatment (sale, range, tiers, badges), use <Price>.
 */
export function PriceLabel({
  value,
  className,
}: {
  /** Price in ILS — currency context handles conversion + symbol. */
  value: number;
  className?: string;
}) {
  const { currency } = useCurrency();
  return <span className={className}>{formatPrice(value, currency)}</span>;
}
